import { Component, inject } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@ngneat/transloco';
import { IconComponent } from '../../../shared/icons/icon.component';
import { IconNameType } from '../../../shared/icons/icon-name-type.enum';
import { ConfigService } from '../../services/config.service';




@Component({
  selector: 'cwo-social-links',
  standalone: true,
  imports: [IconComponent, TranslocoDirective],
  templateUrl: './social-links.component.html',
  styleUrl: './social-links.component.scss',
})
export class SocialLinksComponent {
  configState = inject(ConfigService).configState;
  translocoService = inject(TranslocoService);

  iconNameType = IconNameType;    
}
